<template>
  <Dialog ref="dialog"
          width="430px"
          type="warning"
          mode="centered"
          :close-on="false"
          @confirm="confirm"
          :show-cancel="true"
          :show-close="false"
          :show-confirm="true"
          icon="fas fa-exclamation"
          title="La sesión actual expiró">
    ¿Desea renovar? (Si cancela la sesión finalizará)
  </Dialog>
</template>

<script>
import moment from 'moment';
import { syncRumUserContext, clearRumUserContext } from '@/observability/datadogRum';
import Dialog from '../base/Dialog.vue';
import { apiRequest, updateToken } from '../../../backend/vue-axios/axios';

export default {
  name: 'Refresh',
  components: {
    Dialog,
  },
  data() {
    return {
      interval: 120000, // Intervalo de verificación (2min = 120min)
    };
  },
  mounted() {
    if (this.verifyExpiration()) {
      this.open();
    } else {
      this.$options.interval = setInterval(() => {
        if (this.verifyExpiration()) this.open();
      }, this.interval);
    }
  },
  methods: {
    verifyExpiration() {
      const now = moment.now();
      return (Math
        .ceil(moment(sessionStorage.getItem('expire_token')).diff(now)) / 60000) < 2;
    },
    open() {
      this.$refs.dialog.visible(true);
    },
    confirm(confirm) {
      if (confirm) this.refreshToken();
      else this.closeSession();
    },
    refreshToken() {
      apiRequest({
        module: 'crud',
        service: 'refresh_token',
      }).then((response) => {
        sessionStorage.expire_token = response.data.expire;
        sessionStorage.token = response.data.token;
        updateToken();
        apiRequest({
          module: 'crud',
          service: 'account_info',
        }).then((responseData) => {
          this.onSuccess(responseData);
        }).catch(() => {
          this.onError();
        });
      }).catch(() => {
        this.onError();
      });
    },
    closeSession() {
      clearRumUserContext();
      sessionStorage.clear();
      this.$router.replace(this.$route.query.redirect || '/login');
      this.$refs.dialog.visible(false);
    },
    onError() {
      this.$notify({ type: 'error al extender la sesión', message: 'Por favor vuelva a ingresar' });
      this.closeSession();
    },
    onSuccess(response) {
      sessionStorage.type = response.data.account_types_id;
      sessionStorage.country = response.data.country;
      sessionStorage.user_email = response.data.email || '';
      sessionStorage.user_name = response.data.name || '';
      sessionStorage.user_last_name = response.data.last_name || '';
      syncRumUserContext();
      this.$notify({ type: 'success', title: 'Sesión extendida con éxito' });
      this.$refs.dialog.visible(false);
    },
  },
};
</script>

<style lang="scss" scoped/>
